import type { FC } from "react";
import React, { createContext, useContext } from "react";

import type { LocaleProviderProps } from "./types";

export const LocaleContext = createContext<string>("");

const LocaleProvider: FC<LocaleProviderProps> = ({ locale, children }) => (
  <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
);

export const useLocale = () => useContext(LocaleContext);

export default LocaleProvider;
